export const ModuleGroupRoleTemplateTarget = {
  PropertyTenant: 'property_tenant',
  Unknown: 'unknown',
} as const;

export type ModuleGroupRoleTemplateTargetType =
  (typeof ModuleGroupRoleTemplateTarget)[keyof typeof ModuleGroupRoleTemplateTarget];

export type ModuleGroupRoleTemplate = {
  id: string;
  name: string;
  moduleId: string;
  permissions: string[];
  requirements: string[];
  target: ModuleGroupRoleTemplateTargetType;
  created: Date;
  updated: Date | null;
};

